import { useState } from "react";
import { login } from "../services/apis";
import { useAuth } from "../context/authContext";

export const useLogin = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const { setCode } = useAuth();
  const handleLogin = async (email, code, password) => {
    setLoading(true);
    setError(null);
    try {
      const data = await login(email, code, password);
      // Store login data in localStorage
      localStorage.removeItem("c-code");
      localStorage.setItem("token", data.token);
      localStorage.setItem("userId", data.userId);
      localStorage.setItem("userIds", data.userId);
      localStorage.setItem("email", data.email);
      localStorage.setItem("code", data.code);
      localStorage.setItem("org", data.organisation);
    
      setCode(data.code);
      setLoading(false);
      return data;
    } catch (err) {
      setError(err.response?.data?.message || "An error occurred");
      setLoading(false);
      throw err;
    }
  };

  return { handleLogin, loading, error };
};
